import {
    useState,
    useEffect,
    useRef
} from "react";
import TableauService from "../../services/TableauService";
import UserService from "../../services/UserService";
import {is} from "date-fns/locale";
import ClientService from "../../services/ClientService";

function TableauViz(props) {
    const { tableau } = window;
    const [viz, setViz] = useState(null)
    const urlProgress = "https://data.retailorbit.com/trusted/{user_auth_key}/views/ClientProgressOverview_QA/CLIENTPROGRESSOVERVIEW?:iid=1&:toolbar=top";
    const urlWide = "https://data.retailorbit.com/trusted/{user_auth_key}/views/Client-Wide_QA/CLIENT-WIDEPROGRESSOVERVIEW?:showAppBanner=false&:display_count=n&:toolbar=top&:alerts=n&:subscriptions=n&:dataDetails=n&:showShareOptions=y&:showVizHome=n&:origin=viz_share_link";
    const ref = useRef(null)
    function initViz(){
        TableauService.getTableauUserToken().then(res => {
            const token = res.token

            UserService.getUserClients().then(res => {
                let userUrl;
                let isSingle = false
                if (res.length > 1) {
                    userUrl = urlWide.replace('{user_auth_key}', token)
                } else {
                    isSingle = true
                    userUrl = urlProgress.replace('{user_auth_key}', token)
                }
                let clientList = res ?? 0
                let params = {
                    'height': '85vh',
                    'width': '100%',
                    'hideTabs':false,
                    'hideToolbar': false,
                    'onFirstInteractive': function () {
                        //viz.hide();
                        _viz.getWorkbook().changeParameterValueAsync('epochMonthRM', Number(ClientService.getEpochMonthFromDate(new Date())));
                        if(isSingle){
                            _viz.getWorkbook().changeParameterValueAsync('Clientid', Number(clientList.toString()));
                        }
                        _viz.refreshDataAsync().then(success =>  {
                            _viz.show();
                        });

                    }
                }
                if (isSingle) {
                    params.Clientid = clientList.toString()
                }
                let _viz = new tableau.Viz(ref.current, userUrl, params);

                setViz(_viz)
            })
        })

    }

    function dropViz() {
        if (viz) {
            viz.dispose()
        }
    }

    useEffect(() => {
        initViz();
    },[])

    useEffect(() => {
        return () => {
            // componentwillunmount in functional component.
            dropViz()
        }
    }, [])

    return <>
        <div ref={ref}></div>
    </>
}

export default TableauViz